import { render, staticRenderFns } from "./reciboPDF.vue?vue&type=template&id=9c9e0f20&scoped=true&"
import script from "./reciboPDF.vue?vue&type=script&lang=js&"
export * from "./reciboPDF.vue?vue&type=script&lang=js&"
import style0 from "./reciboPDF.vue?vue&type=style&index=0&id=9c9e0f20&lang=scss&scoped=true&"
import style1 from "./reciboPDF.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9e0f20",
  null
  
)

export default component.exports